<template>
  <div>
    <div class="gdlr-core-pbf-wrapper" id="gdlr-core-wrapper-2">
      <div class="gdlr-core-pbf-background-wrap">
        <div
          class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
          id="div_1dd7_13"
          data-parallax-speed="0.8"
        ></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div
          class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container-custom"
        >
          <div
            class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first"
          >
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js"
              id="div_1dd7_14"
              data-sync-height="height-1"
              style="height: 480px;"
            >
              <div
                class="gdlr-core-pbf-background-wrap"
                data-aos="fade-up"
                data-aos-duration="1500"
                data-aos-delay="500"
              >
                <div
                  :style="
                    about && about.image != ``
                      ? 'background-image: url(' + about.image + ')'
                      : 'background-image: url(' +
                        require('@/assets/images/template4/about-bg-2.jpg') +
                        ')'
                  "
                  class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                  id="div_1dd7_15"
                  data-parallax-speed="0"
                ></div>
              </div>
              <div
                class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content"
              ></div>
            </div>
          </div>
          <div
            class="gdlr-core-pbf-column gdlr-core-column-30"
            id="gdlr-core-column-4"
          >
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js"
              id="div_1dd7_16"
              data-sync-height="height-1"
              style="height: 480px;"
            >
              <div class="gdlr-core-pbf-background-wrap">
                <div
                  class="gdlr-core-pbf-background parallax-background gdlr-core-js"
                  id="div_1dd7_17"
                  data-parallax-speed="0.1"
                  style="height: 495.6px; transform: translate(0px, -9.35781px)"
                  :style="
                    'background-image: url(' +
                      require('@/assets/images/template4/about-bg-2.jpg') +
                      ')'
                  "
                ></div>
              </div>
              <div
                class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content"
                data-aos="fade-down"
                data-aos-duration="1500"
                data-aos-delay="500"
              >
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr"
                    id="div_1dd7_18"
                  >
                    <div class="gdlr-core-title-item-title-wrap clearfix">
                      <h3
                        class="gdlr-core-title-item-title gdlr-core-skin-title"
                        id="h3_1dd7_4"
                      >
                        Tentang Kami
                      </h3>
                    </div>
                    <span
                      class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                      id="span_1dd7_0"
                      >{{ about.title }}</span
                    >
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                    id="div_1dd7_19"
                  >
                    <div
                      class="gdlr-core-text-box-item-content"
                      id="div_1dd7_20"
                      v-html="about.body"
                    ></div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                  >
                    <a
                      class="gdlr-core-button gdlr-core-button-solid gdlr-core-button-no-border"
                      href="#"
                      id="a_1dd7_0"
                      ><span class="gdlr-core-content">Bergabung</span></a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "visi-misi",
  props: ["about"],
};
</script>
